(function (Translator) {
    // et
    Translator.add("rate_list.rate.bg_kbcbank", "KBC Bank summa", "EvpThemeBundle", "et");
    Translator.add("recaptcha.description", "Selle s\u00f5numi eesm\u00e4rk on kindlaks teha, kas isik kasutab brauserit, ja v\u00e4ltida automaatseid kontrollis\u00fcsteeme", "EvpThemeBundle", "et");
    Translator.add("recaptcha.title", "Kas sa oled robot?", "EvpThemeBundle", "et");
})(Translator);
